import React from "react";
import { Typography, Button, Box } from "@material-ui/core";
import { useHistory } from "react-router-dom";

export default function NotFound() {
  const history = useHistory();
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
      <Typography variant="h1" color="textSecondary">404</Typography>
      <Typography variant="h5" gutterBottom>Page not found</Typography>
      <Button variant="contained" color="primary" onClick={() => history.push("/portal")}>Go to Portal</Button>
    </Box>
  );
}
